import { getDeliveryEstimate } from './actions/get-delivery-estimate';
import { validateOrderFulfillmentTime } from './actions/validate-order-fulfillment-time';
import { setOrderFulfillmentTime } from './actions/set-order-fulfillment-time';
import { addUpsellItemsToOrder } from './actions/add-upsell-items-to-order';


const orderAhead = {
  namespaced: true,

  actions: {
    getDeliveryEstimate,
    validateOrderFulfillmentTime,
    setOrderFulfillmentTime,
    addUpsellItemsToOrder
  }
};

export { orderAhead };
